module.exports = __webpack_public_path__ + "images/ris_logo-b1b6c52d51b709b7175492547d3a20ca.png";


//////////////////
// WEBPACK FOOTER
// ./app/frontend/images/ris_logo.png
// module id = 55
// module chunks = 0